import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/shared/auth.service';
import { WebshopService } from 'src/app/services/webshop/webshop.service';
import { environment } from '../../../../../../environments/environment';
import { common_environment } from '../../../../../../environments/common.environment';
import { DeliveryPlatformService } from 'src/app/services/delivery/delivery-platform.service';
import { PosService } from 'src/app/services/pos/pos.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-sidenav-v2',
  templateUrl: './sidenav-v2.component.html',
  styleUrls: ['./sidenav-v2.component.scss']
})
export class SidenavV2Component implements OnInit {

  isNewCustomer: boolean = false;
  route: any
  isAdminUser: boolean = false;
  loggedUser: any;
  userPolices: any = [];
  locationAccess = false;
  brandsAvailable = false;
  hasWebSetup: boolean = false;
  logoUrl: any = `${environment.logo_url}`
  storeName: any = `${environment.store_name}`
  tenantId: any = `${environment.tenant_id}`
  appVersion: any = `${common_environment.app_version}`

  constructor(
    private deliveryService: DeliveryPlatformService,
    private userService: UserService,
    private authService: AuthenticationService,
    private webshopService: WebshopService,
    private activeRoute: ActivatedRoute,
    private posService: PosService,
  ) { }

  ngOnInit(): void {

    this.activeRoute.queryParamMap.subscribe((paramMap) => {
      const refresh = paramMap.get('refresh');
      console.log(paramMap)
      this.getWebshop();
    });
    this.getCurrentUser();
    this.getAllBrands()


  }

  getCurrentUser() {
    this.userService.getCurrentUser().subscribe((res) => {

      this.authService.storeUser(res.data);
      this.authService.setReportToken(res.data.report_service_token);

      console.log(this.authService.getLoggedUser(), 'LoggedUser SideNav')
      this.loggedUser = this.authService.getLoggedUser();

      if (this.loggedUser.user_roles.role_id == 1 || this.loggedUser.user_roles.role_id == 2) {
        this.isAdminUser = true;
      } else {
        this.isAdminUser = false;
      }

      let policies = this.authService.getLoggedUser().policies

      policies.forEach(element => {

        if (element.id == 10 || element.id == 11) {
          this.userPolices.push(element.id)
          this.locationAccess = true;
        }
      });


    })
  }

  getPlatforms() {
    this.deliveryService.getAllPlatforms().subscribe((res) => {

      let platforms = res.data;
      if (platforms.length > 0) {
        this.isNewCustomer = false;
      } else {
        this.isNewCustomer = true;
      }

    })
  }

  getMenus() {

    this.posService.getMenus().subscribe((res) => {
      let menus = res.data.menus;
      if (menus.length > 0) {
        this.isNewCustomer = false;
      } else {
        this.isNewCustomer = true;
      }
    })
  }

  getWebshop() {
    console.log('hasWebSetup')
    this.webshopService.getTenantByID(this.tenantId)
      .subscribe((res) => {
        console.log(res.data)
        let hasWebshop = res.data.has_webshop;
        if (hasWebshop == 1) {
          this.hasWebSetup = true;
        } else {
          this.hasWebSetup = false;
        }
      })
  }

  getAllBrands() {
    this.webshopService.getAllBrands()
      .subscribe({
        next: (res) => {
          console.log(res, "allBrands");
          if (res.data.webshop_brands.length > 0)
            this.brandsAvailable = true
        },
        error: (error) => {
          this.brandsAvailable = false
        }
      });
  }

  logout() {
    this.authService.logout();
    window.location.href = '/login';
  }
}
